export { ResultsPerPage } from './ResultsPerPage';
export type {
  ResultsPerPageControlProps,
  ResultsPerPageProps,
} from './ResultsPerPage.types';
export { ResultsPerPageControl } from './ResultsPerPageControl';
